// ════════════════════════════════════════════════════════════════════════
//  Lehrgangsblick – die Matrix, aufklappbar und für EINEN Lehrgang
//
//  „Hakt Lektion 4 bei allen?“ ist eine echte Frage, nur nicht die häufigste.
//  Deshalb steht die Matrix unter der Übersicht und ist zu, wenn die Seite
//  aufgeht.
//
//  Die Lehrgangswahl ist ein FILTER, keine Navigation: die Übersicht darüber
//  zeigt weiterhin alle Lehrgänge gleichzeitig. Gewählt wird nur, welche Matrix
//  gerade aufgeschlagen ist – sonst wäre es ein zweiter Weg zu denselben Zielen,
//  und genau daran sind die Tabs der Admin-App gescheitert.
// ════════════════════════════════════════════════════════════════════════

import { useState } from "react";
import type { Bundle } from "@otto/lehrgang";
import type { ClassCourse } from "../../courses/lib/data.js";
import type { StudentRow } from "../lib/data.js";
import { ResultsTable } from "./ResultsTable.js";
import own from "./CourseMatrix.module.css";
import styles from "../../../shared/components/shell.module.css";

export function CourseMatrix({
  courses,
  rows,
}: {
  courses: readonly (ClassCourse & { bundle: Bundle })[];
  rows: readonly StudentRow[];
}) {
  const [chosen, setChosen] = useState<string | null>(null);
  if (courses.length === 0) return null;

  const course = courses.find((c) => c.curriculumId === chosen) ?? courses[0]!;

  return (
    <details className={own.box}>
      <summary className={own.summary}>Lektion für Lektion ansehen</summary>

      <p className={styles.subtitle}>
        Eine Spalte je Lektion, eine Zeile je Kind – für die Frage, ob eine bestimmte
        Lektion in der ganzen Klasse hakt.
      </p>

      {/* Eine Auswahl mit einem Eintrag ist keine. */}
      {courses.length > 1 && (
        <div className={own.picker} role="group" aria-label="Lehrgang wählen">
          {courses.map((option) => (
            <button
              key={option.curriculumId}
              type="button"
              className={
                option.curriculumId === course.curriculumId
                  ? `${own.choice} ${own.chosen}`
                  : own.choice
              }
              aria-pressed={option.curriculumId === course.curriculumId}
              onClick={() => setChosen(option.curriculumId)}
            >
              {option.title}
            </button>
          ))}
        </div>
      )}

      <ResultsTable bundle={course.bundle} rows={rows} />
    </details>
  );
}
